export default __webpack_public_path__ + "media/images/isle-of-man-7662e00d2ccdb1176af1eb306d93db96.png";